var map = {
	"./q1.png": 5491,
	"./q2.png": 9880,
	"./q3.png": 1009,
	"./q4.png": 2526,
	"./q5.png": 2023,
	"./q6.png": 8092,
	"./q7.png": 357,
	"./q8.png": 8978,
	"./q9.png": 9483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 809;